module.exports = __webpack_public_path__ + "static/media/obed-vecera.b44e1bec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/vychovakzivotu/resources/obed-vecera.jpg
// module id = 468
// module chunks = 0